document.addEventListener('click', event => {
  if( event.target.classList.contains('nav_open_toggle') ) {
    document.body.classList.toggle('nav_state__open');
    window.scrollTo(0,0);
  }
});
